import React from 'react';

export default function NavRightButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className="absolute z-10 image-gallery-right-nav sm:-right-7"
    >
      <div className="w-10 h-10 flex items-center justify-center shadow-nav-button rounded-full bg-white-75">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          className="w-7 h-7 text-content-secondary"
        >
          <path
            fillRule="evenodd"
            d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z"
            clipRule="evenodd"
          />
        </svg>
      </div>
    </button>
  );
}
